import React from 'react'
import { IInvoice } from '@root/query'
import { PostDueAutomationInactiveAlert } from './PostDueAutomationInactiveAlert'
import { PostDueAutomationOffAlert } from './PostDueAutomationOffAlert'

interface Props {
  invoice: IInvoice
  onOpenPostDueSettings: () => void
}

export const PostDueAutomationDetailAlerts: React.FC<Props> = ({
  invoice,
  onOpenPostDueSettings
}) => (
  <>
    <PostDueAutomationInactiveAlert invoice={invoice} />
    <PostDueAutomationOffAlert invoice={invoice} onOpenPostDueSettings={onOpenPostDueSettings} />
  </>
)
